import { useState } from 'react';
import {
  Window,
  WindowActionsBar,
  WindowProps
} from '@progress/kendo-react-dialogs';
import { RadioButton } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { Col, Row } from 'react-bootstrap';

interface TaskDownloadWindowProps extends WindowProps {
  toggleDialog: () => void;
  onDownload: (type: 'photos' | 'videos' | 'all') => void;
}

export const TaskDownloadWindow = ({
  toggleDialog,
  onDownload,
  ...props
}: TaskDownloadWindowProps) => {
  const [selectedOption, setSelectedOption] = useState<
    'photos' | 'videos' | 'all'
  >('photos');

  return (
    <Window
      modal
      className="shadow"
      initialWidth={500}
      initialHeight={260}
      onClose={toggleDialog}
      title="Select an option"
      {...props}>
      <Row className="mt-2">
        <Col md="12">
          <RadioButton
            name="downloadOptions"
            label="Download all photos answers"
            checked={selectedOption === 'photos'}
            onChange={() => setSelectedOption('photos')}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="12">
          <RadioButton
            name="downloadOptions"
            label="Download all videos answers"
            checked={selectedOption === 'videos'}
            onChange={() => setSelectedOption('videos')}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="12">
          <RadioButton
            name="downloadOptions"
            label="Download all answers"
            checked={selectedOption === 'all'}
            onChange={() => setSelectedOption('all')}
          />
        </Col>
      </Row>
      <WindowActionsBar>
        <Button themeColor="secondary" onClick={toggleDialog}>
          Cancel
        </Button>
        <Button themeColor="primary" onClick={() => onDownload(selectedOption)}>
          Download
        </Button>
      </WindowActionsBar>
    </Window>
  );
};
